<template>
    <TransitionRoot
        as="template"
        :show="state.open"
    >
        <Dialog
            as="div"
            class="relative z-6000"
            :open="state.open === true"
            @close="dialogClose(state.overlayPreventClose)"
        >
            <TransitionChild
                as="template"
                enter="ease-out duration-300"
                enter-from="opacity-0"
                enter-to="opacity-100"
                leave="ease-in duration-200"
                leave-from="opacity-100"
                leave-to="opacity-0"
            >
                <div class="fixed inset-0 bg-black opacity-75 transition-opacity" />
            </TransitionChild>

            <div class="fixed inset-0 z-10 overflow-y-auto">
                <div
                    class="flex min-h-full items-end justify-center p-4 text-center sm:items-center sm:p-0"
                >
                    <TransitionChild
                        as="template"
                        enter="ease-out duration-300"
                        enter-from="opacity-0 translate-y-4 sm:translate-y-0 scale-0"
                        enter-to="opacity-100 translate-y-0 scale-100"
                        leave="ease-in duration-200"
                        leave-from="opacity-100 translate-y-0 scale-100"
                        leave-to="opacity-0 translate-y-4 sm:translate-y-0 scale-0"
                    >
                        <DialogPanel
                            class="relative transform overflow-hidden rounded-lg bg-white px-4 pt-5 pb-4 text-left shadow-xl transition-all sm:my-8 sm:w-full sm:max-w-7xl sm:p-6"
                        >
                            <div class="absolute top-0 right-0 hidden pt-4 pr-4 sm:block">
                                <button
                                    type="button"
                                    class="rounded-md bg-white text-gray-400 hover:text-gray-500 focus:outline-hidden"
                                    @click="dialogClose()"
                                >
                                    <span class="sr-only">Close</span>
                                    <MdiClose
                                        class="h-6 w-6"
                                        aria-hidden="true"
                                    />
                                </button>
                            </div>
                            <div class="sm:flex sm:items-center sm:justify-start">
                                <div
                                    class="mx-auto flex h-12 w-12 shrink-0 items-center justify-center rounded-full bg-gray-200 sm:mx-0 sm:h-10 sm:w-10"
                                >
                                    <MdiQrcodePlus
                                        class="h-6 w-6 text-gray-600"
                                        aria-hidden="true"
                                    />
                                </div>
                                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                    <DialogTitle
                                        as="h3"
                                        class="text-base leading-6 font-semibold text-gray-900 select-none"
                                    >
                                        {{ t('buttonInsertAsImageCode') }}
                                    </DialogTitle>
                                </div>
                            </div>
                            <!-- Content builder area -->
                            <div class="mt-2 w-full">
                                <div
                                    v-for="imageCodeType in imageCodeTypes"
                                    :key="imageCodeType.id"
                                    class="flex cursor-pointer items-center gap-2 rounded border border-gray-300 p-2 hover:bg-gray-100"
                                    @click="conditions.push(imageCodeType)"
                                >
                                    {{ imageCodeType.name }}

                                    <div
                                        v-for="val in imageCodeType.model"
                                        :key="val"
                                        class="flex flex-col items-center gap-1 rounded bg-gray-200 p-1 text-xs"
                                    >
                                        <span class="font-mono text-gray-600">
                                            {{ val.name }}
                                        </span>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-5 justify-end gap-2 sm:mt-4 sm:flex">
                                <ActionButton
                                    :value="t('buttonInsertImageCode')"
                                    state="primary"
                                    :icon="MdiQrcodePlus"
                                    :is-disabled="conditions.length === 0"
                                    @click="dialogClose()"
                                />
                            </div>
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>

<script setup>
import { reactive } from 'vue';
import ActionButton from '../ui/ActionButton.vue';
import { Dialog, DialogPanel, DialogTitle, TransitionChild, TransitionRoot } from '@headlessui/vue';
import { MdiQrcodePlus, MdiClose } from 'materialdesignicons-vue3/icons/';
import { getImageCodeTypes } from '../composables/useImageCodes';

defineExpose({
    name: 'ImageCodeEditor',
});

const props = defineProps({
    state: {
        type: Object,
        required: true,
    },
});

const conditions = reactive([]);
const state = props.state;
const imageCodeTypes = getImageCodeTypes();

const dialogClose = (preventClose = false) => {
    if (preventClose === false) {
        state.open = false;
    }
};
</script>
